var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.target)?_c(_setup.BPopover,{attrs:{"target":_vm.target,"triggers":"hover","placement":"bottom"}},[_c(_setup.HelpTerm,{attrs:{"term":_vm.term}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }